module.exports = "<div class=\"main-container\">\n\t<router-outlet></router-outlet>\n</div>\n"